/**
 * Represents a rate adjustment with various value fields and a formula.
 */
export class RateAdjustment {

  /**
   * The unique identifier for the rate adjustment.
   */
  id?: string | null;

  /**
   * The unique identifier for the tower.
   */
  towerId?: string | null;

  /**
   * The A value for the rate adjustment.
   */
  aValue?: number | null;

  /**
   * The B value for the rate adjustment.
   */
  bValue?: number | null;

  /**
   * The C value for the rate adjustment.
   */
  cValue?: number | null;

  /**
   * The D value for the rate adjustment.
   */
  dValue?: number | null;

  /**
   * The E value for the rate adjustment.
   */
  eValue?: number | null;

  /**
   * The F value for the rate adjustment.
   */
  fValue?: number | null;

  /**
   * The G value for the rate adjustment.
   */
  gValue?: number | null;

  /**
   * The X value for the rate adjustment.
   */
  xValue?: number | null;

  /**
   * The formula for the rate adjustment.
   */
  formula?: string | null;

  /**
   * To get or set the Variables to calculate rate adjustment
   */
  variables?: Record<string, string> = {};


  /**
  * Created date
  */
  createdOn?: Date | null;
  /**
  * created by user id  
  */
  createdBy?: string | null;
  /**
  * Last modified date 
  */
  lastModifiedOn?: Date | null;
  /**
  * Last modified by user id 
  */
  lastModifiedBy?: string | null;

  /**
  * Created by user name 
  */
  createdByName?: string | null;
  /**
  * Modified by user name 
  */
  lastModifiedByName?: string | null;

  /**
   * calculated value
   */
  calculatedValue?: number | null;

}
